module.exports = __webpack_public_path__ + "static/media/biteship-tlx.d5b9bd29.png";